import React from 'react';
import camelCase from 'camelcase';

const modulesCamelCase = (string) => {
  return camelCase(string);
};

const CamelCase = ({ string }) => (
  <div>{modulesCamelCase(string)}</div>
);

export default CamelCase;
